import { initialLocale, localeAtom } from "@frontend/stores";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { useAtomValue } from "jotai";
import { type ReactNode, useEffect } from "react";

import { messages as enMessages } from "../locales/en/messages";
import { messages as frMessages } from "../locales/fr/messages";

i18n.load({
  en: enMessages,
  fr: frMessages,
});

i18n.activate(initialLocale);

interface LocaleProviderProps {
  children: ReactNode;
}

export function LocaleProvider({ children }: LocaleProviderProps) {
  const locale = useAtomValue(localeAtom);

  useEffect(() => {
    i18n.activate(locale);
  }, [locale]);

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
